<template>
  <div class="-rgb">
    <div class="-format-input -r">
      <span>R</span>
      <input
        type="text"
        class="wt2-text-m wt2-color-negative"
        v-select-on-click
        :value="rgb.r"
        @change="update('r', $event)"
      />
    </div>
    <div class="-format-input -g">
      <span>G</span>
      <input
        type="text"
        class="wt2-text-m wt2-color-negative"
        v-select-on-click
        :value="rgb.g"
        @change="update('g', $event)"
      />
    </div>
    <div class="-format-input -b">
      <span>B</span>
      <input
        type="text"
        class="wt2-text-m wt2-color-negative"
        v-select-on-click
        :value="rgb.b"
        @change="update('b', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rgb: {
      type: Object,
      required: true,
    },

    rgbToHex: {
      type: Function,
      required: true,
    },
  },

  methods: {
    isValidate(number) {
      return number >= 0 && number <= 255;
    },

    update(key, e) {
      const value = parseInt(e.target.value);

      if (this.isValidate(value)) {
        const hex = this.rgbToHex({
          [key]: value,
        });
        this.$emit('update-hex', hex);
      } else {
        // force update to replace the un validated value
        // with the current rgb value
        this.$forceUpdate();
      }
    },
  },
};
</script>
